<template>
  <div>
    <q-form style="text-align: left;" @submit.prevent="updatePassword">
      <q-input
        ref="inputSenha"
        label="Senha"
        v-model="auth.senha"
        dense
        type="password"
        :rules="[
          value => !!value || 'O campo senha é obrigatório!'
        ]"
      />
      <q-input
        label="Confirme a senha"
        v-model="auth.confirmacaoSenha"
        class="q-mt-sm"
        dense
        type="password"
        :rules="[
          value => !!value || 'O campo confirmação de senha é obrigatório!',
          value => value === auth.senha || 'A confiormação de senha deve ser igual a senha!'
        ]"
      />
      <q-btn label="OK" :loading="loading" color="primary" class="full-width q-mt-lg" type="submit" />
    </q-form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { updateUser } from '../../services/usuario'

export default {
  name: 'update-password',
  data () {
    return {
      auth: {
        senha: '',
        confirmacaoSenha: ''
      },
      loading: false
    }
  },
  mounted () {
    this.$refs.inputSenha.focus()
  },
  methods: {
    async updatePassword () {
      try {
        this.loading = true
        const usuario = Object.assign({}, this.usuarioLogado,  { senha: this.auth.senha })
        await updateUser(usuario)
        this.$q.notify({
          color: 'green',
          position: 'top-right',
          icon: 'check',
          message: 'Sua senha foi alterada com sucesso!'
        })
        this.$emit('passwordUpdated')
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    usuarioLogado () {
      return this.$store.getters.getUsuario
    }
  },
  validations: {
    auth: {
      senha: {
        required
      },
      confirmacaoSenha: {
        required
      }
    }
  }
}
</script>